module.exports = __webpack_public_path__ + "/img/Dfn4-Custom-Footprint-xhULBa.svg";